export const MYSELF = "myself";

export const CHILD = "child";

export const PET = "pet";
